"use client"

import { useAppForCurrentLocale } from "@/src/utils/locale/useAppForCurrentLocale"
import { getDepictLangCode } from "@/src/utils/depict/getDepictLangCode"
import { getDepictMarketCode } from "@/src/utils/depict/getDepictMarketCode"

/**
 * Bucket A consumer — Depict market + locale code derived from the URL locale.
 *
 * Replaces the previous `useEcommerceStore` reads which (a) violated the project's
 * "individual selectors only" Zustand rule by destructuring an object selector
 * (creating a new reference every render → unnecessary re-renders) and (b) read
 * from `basketSession.metadata` which is `null` for browsing visitors after
 * Phase 2's store cleanup.
 */
const useDepictClientMarketAndLocaleCode = () => {
    const app = useAppForCurrentLocale()

    const marketCode = getDepictMarketCode(app.countryCode ?? "")
    const localeCode = getDepictLangCode(app.language)

    return { marketCode, localeCode }
}

export default useDepictClientMarketAndLocaleCode
